import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-participant-bonus',
  templateUrl: './participant-bonus.component.html',
  styleUrls: ['./participant-bonus.component.css'],
  standalone: true
})
export class ParticipantBonusComponent {

  constructor() { }
 
}
